import { Grid } from '@zappyrent/hundop';

import { StyledWrapper } from './Main.styles';
import { IMainProps } from './Main.types';

const Main = ({ children }: IMainProps): JSX.Element => {
  return (
    <Grid container direction="column">
      <StyledWrapper>{children}</StyledWrapper>
    </Grid>
  );
};

export default Main;
